import React from "react";
import "./About.css";
import AboutImage from "../../../../assets/images/about.png";
import AboutShape1 from "../../../../assets/images/about-shape1.png";
import AboutShape2 from "../../../../assets/images/about-shape2.png";
import AboutShape3 from "../../../../assets/images/about-shape3.png";

const About = () => {
  return (
    <div className="about__section">
      <img src={AboutShape1} className="about__section_shape1" />
      <img src={AboutShape2} className="about__section_shape2" />
      <img src={AboutShape3} className="about__section_shape3" />
      <div className="about__section_left">
        <img src={AboutImage} className="about__section_leftimg" />
      </div>
      <div className="about__section_right">
        <div className="about__secright_title">SEE OUR PROCESS</div>
        <div className="about__secright_mission">
          Our mission is to produce the highest quality work for every client,
          on every project
        </div>
        <div className="about__secright_steps">
          <div className="about__secright_step">
            <div className="about__secright_stepicon">1</div>
            <div className="about__secright_steptext">
              Register Free with Necessary Details
            </div>
          </div>
          <div className="about__secright_step">
            <div className="about__secright_stepicon">2</div>
            <div className="about__secright_steptext">
              Prepare and review your tax returns
            </div>
          </div>
          <div className="about__secright_step">
            <div className="about__secright_stepicon">3</div>
            <div className="about__secright_steptext">
              Secure Payment By PayPal Or Mastercard
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
